// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3524) return "static/chunks/2170a4aa-97b2c42d43996a14.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1571":"b3bf860871113176","6403":"b5708c39079af4c1","8436":"cab94b59cca0a8ff","8694":"b1924187a7e044b1"}[chunkId] + ".js";
};